module.exports = __webpack_public_path__ + "static/media/ic-remove-duplicate.fb0ddb8b.svg";